module.exports = __webpack_public_path__ + "img/073424.cca3d393.png";